import { Inter, Manrope } from "next/font/google";

export const inter = Inter({
  variable: "--font-inter",
  subsets: ["latin", "cyrillic", "latin-ext"],
  weight: ["400", "600", "700"],
  display: "swap",
});

export const manrope = Manrope({
  variable: "--font-manrope",
  subsets: ["latin", "cyrillic", "latin-ext"],
  weight: ["600", "700"],
  display: "swap",
});

/** Manrope Bold — заголовки H1/H2 (Next.js className, не только CSS-переменная). */
export const displayFontClassName = manrope.className;
